// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1741": "ed8b60c33ff9","4764": "3635aeb97f78","5113": "d16f9710659f","6563": "c118f70d3cdb","8270": "72223c79a1b1","927": "f921d25b46de",}[chunkId] + ".css"
}